import moment from 'moment'

import { IShipTpEvent } from '../domain/TransportPlanEvent'
import { ICargoProcess, ICarriagePlan } from './TransportPlan2'

export const getAllEvents = (carriagePlans: (ICargoProcess | ICarriagePlan)[]): ICarriagePlan['events'] => {
  return carriagePlans.reduce(
    (allEvents, carriagePlan) => {
      return {
        ...allEvents,
        ...(carriagePlan && carriagePlan.events),
      }
    },
    {} as ICarriagePlan['events']
  )
}

export const getTpEventsSortedByDate = (events: IShipTpEvent[]) => {
  // furthest first
  return events.slice().sort((a, b) => {
    if (!b.aggregatedTimestamp) {
      return -1
    }
    if (!a.aggregatedTimestamp) {
      return 1
    }
    if (b.aggregatedTimestamp.date > a.aggregatedTimestamp.date) {
      return 1
    }
    if (a.aggregatedTimestamp.date > b.aggregatedTimestamp.date) {
      return -1
    }
    return 0
  })
}

export const getTpEventsSortedByDelay = (events: IShipTpEvent[]) => {
  // biggest delay first
  return events
    .filter((event) => event.aggregatedTimestamp)
    .sort((a, b) => {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      if (a.aggregatedTimestamp.delay === b.aggregatedTimestamp.delay) {
        // if same delay, then we take one that has reason
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        return a.aggregatedTimestamp.reason ? -1 : 1
      }
      // use 0 if delay is undefined
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      return a.aggregatedTimestamp.delay > (b.aggregatedTimestamp.delay || 0) ? -1 : 1
    })
}

const getDifferenceInDays = (startDate: string | null, endDate: string | null): number | null => {
  if (!startDate || !endDate) return null

  const startDateTrimmed = moment(startDate).startOf('day')
  const endDateTrimmed = moment(endDate).startOf('day')

  return endDateTrimmed.diff(startDateTrimmed, 'days')
}

export const getDurationInCalendarDays = (
  firstEvent: IShipTpEvent | undefined,
  secondEvent: IShipTpEvent | undefined
): number | null => {
  if (!firstEvent || !secondEvent) return null

  const [startDate, endDate] = [firstEvent, secondEvent].map((event) => event.aggregatedTimestamp?.date ?? null)

  return getDifferenceInDays(startDate, endDate) ?? null
}
